import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { setEspEquipments, setHfEstimatedCurrentAmps, setHfFilterSelection, setHfInstallationType, setHfRecommendedFilterAndSelectionList, setPowerField, setSelectedTransformer, setSurfaceCalculationComplete, setWeightField, setFetchSwitchControllerLoad, setSelectedVSD, setSelectedSwitchBoard } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";

export const useSurfaceEquipmentFacade = () => {
    const dispatch = useAppDispatch();

    const updateSurfaceCalculationComplete = (payload: boolean) => {
        return dispatch(setSurfaceCalculationComplete({ payload }));
    };

    const updateHfInstallationType = (payload: any) => {
        return dispatch(setHfInstallationType(payload));
    };

    const updateHfEstimatedCurrentAmps = (payload: any) => {
        return dispatch(setHfEstimatedCurrentAmps(payload));
    };

    const updateHfRecommendedFilterAndSelectionList = (payload: any) => {
        return dispatch(setHfRecommendedFilterAndSelectionList(payload));
    };

    const updateHfFilterSelection = (payload: any) => {
        return dispatch(setHfFilterSelection(payload));
    };

    const updatePowerField = (payload: number) => {
        return dispatch(setPowerField(payload));
    };

    const updateSelectedTransformer = (payload: any) => {
        return dispatch(setSelectedTransformer(payload));
    };

    const updateESPEquipments = (payload: any) => {
        return dispatch(setEspEquipments(payload));
    };

    const updateWeightField = (payload: string) => {
        return dispatch(setWeightField(payload));
    };

    const fetchSwitchControllerLoad = async (payload: any) => {
        return await dispatch(setFetchSwitchControllerLoad(payload));
    };

    const updateSelecltedVSD = (payload: any) => {
       return dispatch(setSelectedVSD(payload));
    };

    const updateSelectedSwitchBoard = (payload: any) => {
        return dispatch(setSelectedSwitchBoard(payload));
    };

    const getTransformerEquipments = () => {
        return dispatch({ type: "surface/fetchTransformers" })
    };

    return {
        updateSurfaceCalculationComplete,
        updateHfInstallationType,
        updateHfEstimatedCurrentAmps,
        updateHfRecommendedFilterAndSelectionList,
        updateHfFilterSelection,
        updatePowerField,
        updateSelectedTransformer,
        updateESPEquipments,
        updateWeightField,
        fetchSwitchControllerLoad,
        updateSelecltedVSD,
        updateSelectedSwitchBoard,
        getTransformerEquipments,
    };
}
